export default "__VITE_ASSET__zYPUGgCf__"